import React from 'react';
import { Row, Col, Card, Collapse } from 'react-bootstrap';

import { render_marked_text } from '../utils/HiddenText';

function EntityClarity({
	analysis_results,
	show_entity,
	set_show_entity
}){

	const render_entity_clarity_section = ()=> {
		const data = analysis_results.entity_clarity;
		if(!data){
			return;
		}

		return (
			<Card className="analysis-results-card entity-clarity-card">
				<h3 className="entity-clarity-title" onClick={()=>set_show_entity(!show_entity)} style={{cursor:'pointer'}}>
					Entity Clarity {show_entity ? "▲" : "▼"}
				</h3>
				<p className="entity-clarity-desc">
					How clearly the page identifies people, places, products, and other named entities.
				</p>

				<Collapse in={show_entity}>
				<div>
				<Row>
					<Col md={4}>
						<div className="entity-clarity-bool-list">
							<div className={
								"entity-clarity-bool-item " +
								(data.entities_detected.length > 0 ? "entity-clarity-bool-true" : "entity-clarity-bool-false")
							}>
								<span className="entity-clarity-icon"></span>
								<span className="entity-clarity-bool-label">Topic entities detected</span>
							</div>

							<div className={
								"entity-clarity-bool-item " +
								(data.entities_unclear.length === 0 ? "entity-clarity-bool-true" : "entity-clarity-bool-false")
							}>
								<span className="entity-clarity-icon"></span>
								<span className="entity-clarity-bool-label">No ambiguous entities</span>
							</div>
						</div>
					</Col>

					<Col md={8}>

						<div className="entity-section-group">
							<div className="entity-section-heading">Entities detected</div>
							{data.entities_detected.map((text, index)=>(
								<div key={index} className="entity-text-box">{render_marked_text(text, analysis_results)}</div>
							))}
						</div>

						{(data.entities_unclear.length > 0) && (
							<div className="entity-section-group">
								<div className="entity-section-heading">Unclear entities</div>
								{data.entities_unclear.map((text, index)=>(
									<div key={index} className="entity-text-box">{text}</div>
								))}
							</div>
						)}

						{(data.entity_clarity_notes.length > 0) && <div className="entity-section-group">
							<div className="entity-section-heading">Entity notes</div>
							{data.entity_clarity_notes.map((text, index)=>(
								<div key={index} className="entity-text-box">{text}</div>
							))}
						</div>}

					</Col>
				</Row>
				</div>
				</Collapse>
			</Card>
		);
	};

	if(!analysis_results || !analysis_results.entity_clarity){
		return null;
	}

	return render_entity_clarity_section();
}

export default EntityClarity;
